module.exports = {"TXTMOB_SorryX_no_results_were_foundX":{"id":"TXTMOB_SorryX_no_results_were_foundX","defaultMessage":"Ingen resultater."}}